import React, { useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import Carousel from './Carousel';
import './Landing.css';
import phase1Image from '../assets/phase1.jpg';
import phase2Image from '../assets/phase2.jpeg';
import phase3Image from '../assets/phase3.jpg';


const Landing = () => {
    const { user, isAdmin } = useContext(AuthContext);
    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            if (isAdmin) {
                navigate('/adminHome');
            } else {
                navigate('/home');
            }
        }
    }, [user, isAdmin, navigate]);
    const onWaitlistButtonClick = () => {
        window.location.href = 'https://drleahlagos.com/contact/#book-appointment/';
    }

    const carousalContent = {
        slides: [
            "I notice a massive difference in everything related to my cognitive performance. I feel more in control and confident in my decisions. I can also oscillate faster now with no emotions and make my decisions faster.",
            "I feel like I have more energy and focus consistently throughout my game. I am able to access flow more and clear my mind while standing over the ball to putt",
            "I now have this moment in between responses that used to be automatic that I can now pause or decide to subtract before reacting, which makes me more precise in how I respond in key moments."
        ],
        quoteAuth: [
            "Trader for Global Hedge Fund",
            "PGA Tour player",
            "Surgeon for Medical University Center"
        ]
    };

    return (
        <div className="waitlist-page">
            <div className="waitlist-background">
                <div className="main-section-header-container">
                    <div className="main-section-header">A New Paradigm in Elite Performance</div>
                    <div className="main-section-subheader">Access tools, insights and personalized feedback to optimize your Heart Breath and Mind for Elite Performance. Available by application only.</div>
                    <button className="waitlist-btn" onClick={onWaitlistButtonClick}>Join the waitlist</button>
                </div>
            </div>
            <div className="waitlist-section">
                <Carousel slides={carousalContent.slides} auth={carousalContent.quoteAuth} />
                <div className="sub-section-container">
                    <div className="sub-section-header">Get real-time insights to calibrate your best self</div>
                    <div className="sub-section-subheader">Work directly with our team of world class doctors and experts to constantly improve your HRV</div>
                    <div className="sub-section-listitem"><div className="benefits-icon-container"><i className="fa-solid fa-microscope"></i></div>Comprehensive assessments to identify your autonomic nervous system preferences</div>
                    <div className="sub-section-listitem"><div className="benefits-icon-container"><i className="fa-solid fa-users"></i></div>Specific and personalized feedback to help you maximize your autonomic bandwidth and perform in your top quartile of HRV more consistently</div>
                    <div className="sub-section-listitem"><div className="benefits-icon-container"><i className="fa-solid fa-comments"></i></div>Real-time feedback about your autonomic state as you learn, respond, and perform throughout the day</div>
                    <div className="sub-section-listitem"><div className="benefits-icon-container"><i className="fa-solid fa-heart-pulse"></i></div>Predictive analytics to help you make decisions about how to amplify your HRV</div>
                </div>
            </div>
            <div className="waitlist-background">
                <div className="main-section-header-container calibration-container">
                    <div className="main-section-header">Calibrate your Elite Self
                    </div>
                    <div className="main-section-subheader">Optimize your health and performance with precision based technology, personalized insights and real-time feedback.</div>
                    <div className="factors-container">
                        <div>Physiological</div>
                        <div className="plus-icon-container"><i className="fa-solid fa-plus"></i></div>
                    </div>
                    <div className="factors-container">
                        <div>Behavioral </div>
                        <div className="plus-icon-container"><i className="fa-solid fa-plus"></i></div>
                    </div>
                    <div className="factors-container">
                        <div>Environmental </div>
                        <div className="plus-icon-container"><i className="fa-solid fa-plus"></i></div>
                    </div>
                    <div className="factors-container">
                        <div>Psychological</div>
                        <div className="plus-icon-container"><i className="fa-solid fa-plus"></i></div>
                    </div>
                </div>
            </div>
            <div className="waitlist-section no-image">
                <div className="phase-list">
                    <div className="phase">
                        <div className="phase-number">Phase 1</div>
                        <div className="phase-content">
                            <div className="phase-time">Week 1-2</div>
                            <div className="phase-heading">Assessment</div>
                            <p className="phase-text">We analyze a comprehensive dataset from wearable devices and our app, encompassing behavioral, psychological, physiological, and environmental factors. Our advanced machine learning algorithms assess how these elements impact your heart rate variability (HRV), laying a personalized groundwork for improvement. </p>
                        </div>
                        <div className="phase-image">
                            <img src={phase1Image} alt="phase 1 image" />
                        </div>
                    </div>
                    <div className="phase-line"></div>
                    <div className="phase right">
                        <div className="phase-number">Phase 2</div>
                        <div className="phase-content">
                            <div className="phase-time">Week 3-4</div>
                            <div className="phase-heading">Real-time Feedback</div>
                            <p className="phase-text">Receive real time data-driven feedback through our web app, powered by sophisticated analytics and AI. This feedback offers tailored strategies and insights to enhance your health and performance, informed by real-time data processing.</p>
                        </div>
                        <div className="phase-image">
                            <img src={phase2Image} alt="phase 2 image" />
                        </div>
                    </div>
                    <div className="phase-line"></div>
                    <div className="phase">
                        <div className="phase-number">Phase 3</div>
                        <div className="phase-content">
                            <div className="phase-time">Week 4-12</div>
                            <div className="phase-heading">Elite Self Calibration</div>
                            <p className="phase-text">Using cutting-edge analytics, our calibration stage fine-tunes your health and performance strategies. This process helps you maintain elite levels, ensuring you adapt and thrive in any environment. Our web app allows continuous tracking and adjustment based on precise, personalized insights.</p>
                        </div>
                        <div className="phase-image">
                            <img src={phase3Image} alt="phase 3 image" />
                        </div>
                    </div>
                </div>
                <div className="waitlist-last-section-container">
                    <div className="waitlist-last-section">
                        <div className="golfing-img-container">
                            <div className="waitlist-last-section-content">
                                <div className="waitlist-last-section-header">Master your Heart, Breath & Mind</div>
                                <div className="waitlist-last-section-text">Enhancing heart rate variability (HRV) is just the start. We help you improve stress resilience and achieve consistent adaptability through advanced HRV analytics.</div>
                                <button className="waitlist-btn" onClick={onWaitlistButtonClick}>Join the waitlist</button>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="landing-page-footer">
                    <p>© 2025 Heart Breath Mind</p>
                    <Link className="privacy-policy" to="/PrivacyPolicy">Privacy Policy</Link>
                    <Link className="privacy-policy" to="/TermsOfService">Terms Of Service</Link>
                </footer>
            </div>
        </div>
    );
}

export default Landing;